import routes from '@modules/coach/coach-routes';
import store from '@modules/coach/coach-store';

export default {
  routes,
  store,
};
